export const GetWindParkKPITable = "GetWindParkKPITable";
export const GetWindParkKPITableSuccess = "GetWindParkKPITableSuccess";
export const SetWindTurbinesVDI = "SetWindTurbinesVDI";
export const SetWindTurbinesPF = "SetWindTurbinesPF";
export const SetWindTurbines = "SetWindTurbines";
export const SetWindTurbinesFC = "SetWindTurbinesFC";
